import {Injectable, OnDestroy, signal} from '@angular/core';
import {isNativeCapacitorPlatform} from '../platform';
import type {WebAnalyticsConsentChoice, WebAnalyticsConsentState} from './web-analytics-consent.models';
import {webAnalyticsConsentCoordinator} from './web-analytics-consent';

@Injectable({providedIn: 'root'})
export class WebAnalyticsConsentService implements OnDestroy {
  private readonly stateSignal = signal<WebAnalyticsConsentState>(webAnalyticsConsentCoordinator.initialize());
  private readonly unsubscribe = webAnalyticsConsentCoordinator.subscribe((state) => this.stateSignal.set(state));

  readonly isWeb = !isNativeCapacitorPlatform() && typeof document !== 'undefined';

  get state(): WebAnalyticsConsentState {
    return this.stateSignal();
  }

  get dialogOpen(): boolean {
    return this.state.promptOpen;
  }

  get settingsOpen(): boolean {
    return this.state.settingsOpen;
  }

  get collectionEnabled(): boolean {
    return this.state.collectionEnabled;
  }

  get choice(): WebAnalyticsConsentChoice | null {
    return this.state.choice;
  }

  openSettings(): void {
    webAnalyticsConsentCoordinator.openSettings();
  }

  choose(granted: boolean): boolean {
    return webAnalyticsConsentCoordinator.choose(granted ? 'granted' : 'denied');
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }
}
